var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8633C24.8366 32.8633 32 25.6998 32 16.8633C32 8.02672 24.8366 0.863281 16 0.863281C7.16344 0.863281 0 8.02672 0 16.8633C0 25.6998 7.16344 32.8633 16 32.8633Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 23.8195C19.8417 23.8195 22.9562 20.705 22.9562 16.863C22.9562 13.021 19.8417 9.90651 15.9997 9.90651C12.1577 9.90651 9.04321 13.021 9.04321 16.863C9.04321 20.705 12.1577 23.8195 15.9997 23.8195Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.863281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/japan.1cfaef70.svg";
export { ForwardRef as ReactComponent };